import { DisputeTypes } from "../../../shared/constants";
import { FrontOfficeDisputes } from "./disputes";

export function FrontOfficeBankDisputes() {
  return (
    <FrontOfficeDisputes disputeType={DisputeTypes.Frontoffice.BankDisputes} />
  );
}
